module.exports = __webpack_public_path__ + "media/daisy.3524440f.wav";